import { startTransition, useEffect, useState } from 'react';

/**
 * Separates visual show/hide from effect reactivation.
 * - When hidden: effect activity drops immediately (pause timers/requests).
 * - When shown: effect activity resumes in a transition so the paint can
 *   happen before consumers re-render and restart work.
 */
export function useDeferredEffectActive(visible: boolean): boolean {
  const [effectActive, setEffectActive] = useState(visible);

  useEffect(() => {
    if (!visible) {
      setEffectActive(false);
      return;
    }

    startTransition(() => {
      setEffectActive(true);
    });
  }, [visible]);

  return effectActive;
}
